import { Result, Spin } from 'antd';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@/shared/ui';

import { BillingProductAccessState } from '../../config';

import styles from './BillingProductAccessGuard.module.scss';

type BillingProductAccessGuardProps = {
  state: Exclude<BillingProductAccessState, 'allowed'>;
};

export const BillingProductAccessGuard: FC<BillingProductAccessGuardProps> = (
  props,
) => {
  const { state } = props;

  const { formatMessage } = useIntl();

  if (state === 'failed') {
    return (
      <Layout.Content>
        <Result
          status="error"
          title={formatMessage({
            id: 'billingProductAccessGuard.loadFailed',
            defaultMessage: 'Failed to load organization permissions.',
          })}
        />
      </Layout.Content>
    );
  }

  return (
    <Layout.Content>
      <Spin size="large" className={styles.spinner} />
    </Layout.Content>
  );
};
